import type { FileMetaApp, FileId, FileName } from '../../../shared/domain/files/types.no-deps'
import { type FileExtension, extractFileExtension } from '../../../shared/domain/files/fileExtensions.no-deps'

export type FileUploadData = Omit<FileMetaApp, 'isDeleted' | 'createdBy' | 'lastModifiedBy'> & {
    mimeType: string
}

export function createFileUploadData(
    fileId: FileId,
    fileName: string,
    fileSizeInBytes: number,
    mimeType: string
): FileUploadData {
    const extension = extractFileExtension(fileName)

    return {
        fileId,
        fileName: sanitizeName(fileName),
        fileSizeInBytes,
        extension,
        // The created at date is created on the client since it should reflect
        // when the user believes they uploaded the file but since uploads happen
        // in the background this might not be when it is actually uploaded.
        createdAt: new Date(),
        status: 'processing',
        mimeType,
        // This will be populated by the server when the filemeta is synced down
        fetchUrl: null,
    }
}

export function isExtensionValid(fileUploadData: FileUploadData, acceptedExtensions: FileExtension[]) {
    return acceptedExtensions.includes(fileUploadData.extension)
}

export function isFileSizeValid(fileUploadData: FileUploadData, sizeLimitInBytes: number) {
    return fileUploadData.fileSizeInBytes < sizeLimitInBytes
}

export function sanitizeName(name: string) {
    return name.replace(/[^a-zA-Z0-9_\-.\s]/g, '') as FileName
}
